const PAGE_RELOAD_PREPARE_EVENT = 'nearpeer:prepare-page-reload';

const internals = {};

internals.blurElement = (element) => {

    if (!element || typeof element.blur !== 'function') {
        return;
    }

    try {
        element.blur();
    }
    catch (err) {
        // Ignore browser-specific blur failures while the page is leaving.
    }
};

internals.blurNativePickerInputs = () => {

    if (typeof document === 'undefined' || typeof document.querySelectorAll !== 'function') {
        return;
    }

    document.querySelectorAll('input[type="color"]').forEach(internals.blurElement);
};

function prepareForPageReload() {

    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new Event(PAGE_RELOAD_PREPARE_EVENT));
    }

    if (typeof document !== 'undefined') {
        internals.blurElement(document.activeElement);
    }

    internals.blurNativePickerInputs();
}

function reloadPage() {

    prepareForPageReload();

    if (typeof window !== 'undefined' && window.location && typeof window.location.reload === 'function') {
        window.location.reload();
    }
}

module.exports = {
    PAGE_RELOAD_PREPARE_EVENT,
    prepareForPageReload,
    reloadPage,
    internals
};